export function hashColor(badge: string): string {
	let hash = 0
	for (let i = 0; i < badge.length; i++) {
		hash = badge.charCodeAt(i) + ((hash << 5) - hash)
	}
	const hue = Math.abs(hash % 360)
	return `hsl(${hue}, 65%, 40%)`
}
